export const MD_API_ENDPOINTS = {
    //Dashboard
    get_shopname_list: "/api/Apitranxt/get_shopname_list",

    get_provider_dist_view_master_dist: "/api/Apitranxt/get_provider_dist_view_master_dist",
    getUserConfigSettings: "/api/Payment/getUserConfigSettings",
    get_master_tariff_plans: "/api/Apitranxt/get_master_tariff_plans",
    assign_tariff_master: "/api/Apitranxt/user/assign_tariff_master",
    api_master_dist_add_balance: "/api/Apitranxt/api_master_dist_add_balance",
    sendOtp: "/api/Payment/authentication/sendOtp",
    api_master_dist_reverse_balance: "/api/Apitranxt/api_master_dist_reverse_balance",
    validateOtp: "/api/Payment/authentication/validateOtp",

    getDistributorUserBusinessReport: "/api/Admin/v1.0/getDistributorUserBusinessReport",
    getIntraFundTransfer: "/api/Admin/getIntraFundTransfer",
    creditRequestApprove: "/api/Payment/credit/creditRequestApprove",
    creditRequestReverseAmount: "/api/Payment/credit/creditRequestReverseAmount",

    dist_get_provider_list: "/api/Apitranxt/distributor/dist_get_provider_list",

    master_dist_fundreport_v1: "/api/Apitranxt/master_dist_fundreport_v1",
    master_dist_fund_statement_v1: "/api/Apitranxt/master_dist_fund_statement_v1",
    get_commision_chart: "/api/Apitranxt/get_commision_chart",
    panlite: "/api/Verify/panlite",
    aadharotpsend: "/api/Verify/aadharotpsend",
    aadharotpverify: "/api/Verify/aadharotpverify",

    master_dist_check_dist: "/api/Apitranxt/master_dist_check_dist",

    get_distributor_use_report: "/api/Apitranxt/get_distributor_use_report",
    checkpassword: "/api/Apitranxt/checkpassword",

    master_dist_profit_report: "/api/Apitranxt/master_dist_profit_report",
    master_dist_transaction_report_search: "/api/Apitranxt/master_dist_transaction_report_search",
    getWalletBalance: "/api/Payment/wallet/getWalletBalance",
    master_dist_profile_details: "/api/Apitranxt/master_dist_profile_details",
    fetchkycdata: "/api/Apitranxt/kyc/fetchkycdata",
    get_user_access_info: "/api/Apitranxt/user/get_user_access_info",

    getloadbank: "/api/Apitranxt/getloadbank",
    createload: "/api/Apitranxt/createload",
    get_virtualaccountBumppy: "/api/Apitranxt/get_virtualaccountBumppy",
    imageUpload: "/api/Payment/kyc/imageUpload",
    dist_wallet_to_wallet_chk_number: "/api/Apitranxt/distributor/dist_wallet_to_wallet_chk_number",
    dist_wallet_to_wallet_submit: "/api/Apitranxt/distributor/dist_wallet_to_wallet_submit",
    walletToWalletReport: "/api/Payment/v1.0/walletToWalletReport",
 
  };
  